import { NoteEditorSourceBarChip } from "@/components/note/editor/source-bar/NoteEditorSourceBarChip";
import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import { INoteObservable } from "@/store/note";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { FadeHorizontalScroll } from "@/components/horizontal-scroll/FadeHorizontalScroll";
import { useRef } from "react";

interface NoteEditorSourceBar {
  note: INoteObservable;
}

export const NoteEditorSourceBar = observer<NoteEditorSourceBar>(({ note }) => {
  const sources = note.sourceList?.allSupportedSources ?? [];

  const playingSourceIdRef = useRef<string | null>(null);

  if (sources.length === 0) return null;

  return (
    <SourceBarContainer>
      <MdsIcon kind={MdsIconKind.Paperclip} className="paperclip-icon" />
      <ScrollableArea>
        <FadeHorizontalScroll>
          {sources.map(source => (
            <NoteEditorSourceBarChip
              key={source.id}
              source={source}
              note={note}
              playingSourceIdRef={playingSourceIdRef}
            />
          ))}
        </FadeHorizontalScroll>
      </ScrollableArea>
    </SourceBarContainer>
  );
});

const SourceBarContainer = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  padding: "16px",
  gap: "6px",
  backgroundColor: theme.colors.grey.x25,

  "& .paperclip-icon": {
    color: theme.colors.grey.x400,
  },
}));

const ScrollableArea = styled.div({
  flexGrow: 1,
  overflow: "hidden", // Hide the native scrollbar, FadeHorizontalScroll provides its own
});
